import React from 'react'
import { useFormContext } from 'react-hook-form'

import { ProductSelection } from 'modules/ProjectCreate/components'

const ProductsStep = () => {
  const { getValues } = useFormContext()

  const [facebookId, spotifyId, artistName, projectName] = getValues([
    'facebookId',
    'spotifyId',
    'artistName',
    'projectName'
  ])

  return (
    <ProductSelection projectName={projectName} facebookId={facebookId} spotifyId={spotifyId} artistName={artistName} />
  )
}

export default ProductsStep
